import produce from 'immer'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import assetActions from 'actions/assets'
import Component from 'components/DraftOrder/Items/FormView/SelectAsset'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(assetActions.getOptions({ ...params })).then((r) =>
        produce(r, (draft) => {
          if (params.pageIndex <= 1 && !params.search) {
            draft.value.data.items.unshift({ id: 0, displayName: '' })
            draft.value.data.recordCount++
          }
        })
      ),
  }),
})(Component)
